import { Map } from 'immutable';
import _ from 'lodash';

import BaseStore from './BaseStore';
import { ActionTypes } from '../constants/AppConstants';
import Discount from '../records/Discount';

export class DiscountStore extends BaseStore {

    handleLoaded ({ discount }) {
        this.setState(this.state.set(discount.promotionUrl, discount));
    }

    deserialize (serialized) {
        const state = new Map();
        if (serialized) {
            return _.reduce(serialized, (discounts, discount) => discounts.set(discount.promotionUrl, Discount.fromJSON(discount)), state);
        }
        return state;
    }

    getActionHandlers () {
        return {
            [ActionTypes.DISCOUNT_LOADED]: this.handleLoaded
        };
    }
}

const instance = new DiscountStore({ storageKey: 'discounts' });

export default instance;



// WEBPACK FOOTER //
// ./src/stores/DiscountStore.js